// extracted by mini-css-extract-plugin
export var text = "index-module--text--3TDRc";
export var title = "index-module--title--2pXC7";
export var time = "index-module--time--1zHZ0";
export var description = "index-module--description--1X6aA";